<template>
  <div class="aiPayPage">
    <div class="aiPayTitleBg"></div>
    <div class="aiPayContent">
      <div class="aiPayHeader">
        <div class="headerConent">
          <div class="backIconWrap">
            <Icon type="arrow-left" style="color:#fff;" class="backIcon" @click="goBack"/>
          </div>
          <div class="logoWrap">
            <img src="https://webimage.tongxinyiliao.com/ris/images/aiHospitalLogo.png" class="aiPayLogo"/>
          </div>
        </div>
        <div class="aiPayTitleContent">
          <div class="payTitle">{{payInfo.itemsName && payInfo.itemsName[0]}}</div>
          <div class="enTitle">
            <img src="https://webimage.tongxinyiliao.com/ris/images/en-desc.png"/>
          </div>
        </div>
      </div>
      <div class="payPanel">
        <div class="aiPriceWrap">
          <div class="price">
            <div style="text-align:center;height:34px;line-height:34px;">
              <span style="font-size:1.2rem;color:#000;">专家科研价：</span>
              <span style="color:#208cff;font-weight:bolder;font-size:1.5rem;">￥{{payInfo.totalAmount}}</span>
            </div>
            <div style="height:2rem;line-height:2rem; font-size:1rem;">
              <span>原价：</span>
              <span style="text-decoration: line-through;">￥{{payInfo.originalPrice}}</span>
            </div>
          </div>
          <div class="payImageWrap" >
            <img :src="payInfo.payUrl"/>
          </div>
          <div class="payType" v-if="payInfo && payInfo.payType">
            <img src="https://webimage.tongxinyiliao.com/ris/images/weixinPayLabel.png" v-if="payInfo.payType === '线上-微信'"/>
            <img src="https://webimage.tongxinyiliao.com/ris/images/zhifubaoPayLabel.png" v-if="payInfo.payType === '线上-支付宝'"/>
            <div class="tipText">扫描上方二维码付款</div>
          </div>
        </div>
        
      </div>
      <div class="tipContent">
        <p>·划线价格︰指的产品零售价、指导价或该产品的曾经展示过的销售价等，并非原价，仅供参考。</p> 
        <p>·未划线价格∶指产品的实时标价，不因表述的差异改变性质。具体成交价格根据产品参加活动， 最终以订单结算页价格为准</p>
      </div>
    </div>
    <Modal :maskClosable="false" v-model="showPaySuccess" wrapClassName="aiPaySuccessDialog" @cancel="goToQueue">
      <img src="https://webimage.tongxinyiliao.com/ris/images/aiPaySuccess.png" />
    </Modal>
  </div>
</template>
<script>
import Bus from '../../libs/bus'
import { Icon, Modal } from 'ant-design-vue' 
import { getParamFromRoute } from '../../libs/utils'
import { makePayCode } from '../../api/onlineCheckin'
import QRCode from 'qrcode'
export default {
  components: {
    Icon,
    Modal
  },
  data() {
    return {
      routeParams: '',
      payInfo: {},
      showPaySuccess: false
    }
  },
  async created() {
    let params = getParamFromRoute(this.$route)
    if (!params || !params.checkOrderId) return window.history.back()
    this.routeParams = params
    Bus.$on('aiPayMessage', async (data) => {
      if (!data || !data.type ||!data.title) return false
      if (data.title === '欢迎扫码支付') {
        if (data.qrcode) data.payUrl = await QRCode.toDataURL(data.qrcode)
        this.payInfo = data
      }
      if (data.title === '支付成功') {
        this.showPaySuccess = true
      }
    })
    await makePayCode({ checkOrderId: this.routeParams.checkOrderId })
  },
  methods: {
    goBack() {
      return this.$router.replace({path: `/ris/addCheck?checkOrderId=${this.routeParams.checkOrderParentId}&from=queue&isNurseEditFlag=true`})
    },
    goToQueue() {
      return this.$router.replace({path: '/ris/queue'})
    }
  }
}
</script>
<style lang="less">
@import url('../../style/common/variable.less');
.aiPayPage{
  height: 100vh;
  position: relative;
  overflow-x: auto;
  .aiPayTitleBg{
    position:absolute;
    left: 0;
    top:0;
    right: 0;
    height: 16.1rem;
    background: url('@{bgImgDomain}/images/aiHospitalBg.png') no-repeat center center;
    background-size: cover;
    z-index: 1;
  }
  .aiPayContent{
    position: absolute;
    top:0;
    left: 0;
    top:0;
    right: 0;
    z-index: 1;
    .aiPayHeader{
      .headerConent{
        padding: 0 12px 0 16px;
        text-align: center;
        .backIconWrap{
          float: left;
          .backIcon{
            font-weight: 500;
            font-size: 1.2rem;
            margin-top:1.6rem;
          }
        }
        .logoWrap{
          margin-left: -20px;
          text-align: center;
        }
        
      }
      .aiPayLogo{
        margin-top:1.5rem;
        height: 2rem;
      }
    }
    .aiPayTitleContent{
      text-align: center;
      .payTitle{
        font-size:1.6rem;
        color:#fff;
        font-weight:bolder;
        margin-top: .8rem;
      }
      .enTitle{
        img{
          height: 0.8rem;
        }
      }
    }
    .payPanel{
      margin: .8rem 12px 0 1rem;
      border-radius: .9rem;
      background: url('@{bgImgDomain}/images/aiPriceBg.png') no-repeat  center top;
      background-size: cover;
      .aiPriceWrap{
        text-align: center;
        .price{
          padding-top: 1.5rem;
        }
      }
      .payImageWrap{
        img{
          height: 19rem;
          width: auto;
        }
      }
      .payType{
        img{
          height: 1.5rem;
        }
        .tipText{
          padding: .5rem 0 1rem 0;
          color: #208cff;
        }
      }
    }
  }
  .tipContent{
    position: relative;
    margin: .5rem 1rem .8rem 1rem;
    background-color: #fff;
    border-radius: 5px;
    padding: .8rem;
    box-shadow: 0 2px 12px 0 #ebeef5;
    p{
      font-size: .5rem;
      margin: 0;
      color: #6d7685;
    }
  }
}
.aiPaySuccessDialog{
    .ant-modal{
      .ant-modal-content{
        background: transparent;
        .ant-modal-close{
          right: 1rem;
          top: 1rem;
        }
        .ant-modal-body{
          img{
            width: 100%;
          }
        }
      }
      .ant-modal-footer{
        display: none;
      }
    }
  }
</style>